import { getProductDisplayPrice } from '@/feature/product/utils/productDisplayPrice'
import { formatPrice } from '@/lib/formatters/currency.formatter'
import { formatPercentage } from '@/lib/formatters/percentage.formatter'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import type {
  ProductBuyBox_ProductFragment,
  ProductBuyBox_ProductPriceAndStockFragment,
} from '@gql-generated/graphql'

type MergedProductType = ProductBuyBox_ProductFragment &
  Partial<ProductBuyBox_ProductPriceAndStockFragment>

type ProductBuyBoxReferencePublicPriceProps = {
  product: MergedProductType
}

export function ProductBuyBoxReferencePublicPrice({
  product,
}: ProductBuyBoxReferencePublicPriceProps): React.ReactElement | null {
  const { t } = useTranslation(['productBuyBox'])
  const { price } = product
  const referencePercentage = price?.referencePercentage

  const { price: displayedPrice, referencePrice } = getProductDisplayPrice(product)

  if (!referencePrice || !referencePercentage || referencePrice <= displayedPrice) {
    return null
  }

  return (
    <span className="text-sm font-medium text-brand-2-900">
      {t('productBuyBox:referencePublicPrice', {
        public_price: formatPrice(referencePrice),
        discount_from_public_price: formatPercentage(referencePercentage, '+'),
      })}
    </span>
  )
}
